export { getStepIndex } from './getStepIndex';
